<template>
  <div class="referral-article">
		<article class="column feature">
      <div class="column-inner">
        <div class="title-wrap">
          <h3>
            豆蔵の社員紹介制度の特徴
          </h3>
        </div>
        <div class="content">
          <div class="content-inner">
            <div class="content-text">
              <p>
                技術者同士のつながりを活かしながら、情報収集を行っていただけますので、高い納得感を持った上で選考に臨むことができます。また、選考の意思が無くてもエントリー可能です。豆蔵は「技術好き」が集まる会社。すでに多くの方に、社員紹介制度によってご入社いただいています。
              </p>
            </div>
            <div class="image">
              <img src="../../assets/employee_referral_system/feature_img.png" alt="referral" />
            </div>
          </div>
        </div>
      </div>
    </article>
    <a href="https://hrmos.co/pages/mamezou-recruit/jobs/1750416445459521541" target="_blank" class="btn btn-01">
        <p>社員紹介制度へのエントリーはこちら</p>
    </a>
		<article class="column merit full-width">
      <div class="column-inner">
        <div class="title-wrap">
          <h3>
            豆蔵の社員紹介制度のメリット
          </h3>
        </div>
        <div class="content">
          <div class="content-inner">
            <p class="content-catch">
              社員紹介経由で豆蔵に応募する、<br class="under_display">4つのメリットを紹介します。
            </p>
            <div class="merit-item-wrap">
              <div class="merit-item">
                <div class="merit-catch">
                  <div class="num">
                    <p>メリット</p>
                    <span>1</span>
                  </div>
                  <h4>
                    あなた"らしく"<br>働ける
                  </h4>
                </div>
                <div class="content-text">
                  <p>
                    豆蔵があなた”らしさ”を活かせる環境か、判断いただけます。あなたの仕事振りや活躍を知っている社員が生の声をお届けします。
                  </p>
                </div>
              </div>
              <div class="merit-item">
                <div class="merit-catch">
                  <div class="num">
                    <p>メリット</p>
                    <span>2</span>
                  </div>
                  <h4>
                    技術者から<br>生の情報を<br>得ることができる
                  </h4>
                </div>
                <div class="content-text">
                  <p>
                    つながりのある社員を通じて企業文化、社風、仕事内容等の生の情報を得ることで、納得度の高い状態で選考に臨めます。
                  </p>
                </div>
              </div>
              <div class="merit-item">
                <div class="merit-catch">
                  <div class="num">
                    <p>メリット</p>
                    <span>3</span>
                  </div>
                  <h4>
                    応募意思不問で<br>エントリー可能
                  </h4>
                </div>
                <div class="content-text">
                  <p>
                    まずはお気軽にエントリーください。カジュアル面談等の接点を経て、正式にご応募可能です。
                  </p>
                </div>
              </div>
              <div class="merit-item">
                <div class="merit-catch">
                  <div class="num">
                    <p>メリット</p>
                    <span>4</span>
                  </div>
                  <h4>
                    入社お祝い金を<br>支給
                  </h4>
                </div>
                <div class="content-text">
                  <p>
                    ご入社が決定した際、入社された方にお祝い金を支給いたします。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
		<article class="column position">
      <div class="column-inner">
        <div class="title-wrap">
          <h3>
            募集職種
          </h3>
        </div>
        <div class="content">
          <div class="content-inner">
            <div class="content-text">
              <p>
                豆蔵の代表的な4つの事業領域「ビジネスプラットフォーム領域（エンタープライズ領域）」「エンベデッド領域（組込領域）」「ロボット領域」「DX・AIソリューション領域」において、開発エンジニア、アーキテクト、テックリード、コンサルタント、ロボット系エンジニア、データサイエンティスト、研修講師など、幅広いポジションでの募集を行っています。フルリモート勤務のポジションも多くあります。
              </p>
            </div>
            <div class="example-wrap">
              <h4 class="example-ttl">
                募集職種例
              </h4>
              <div class="example-item-wrap">
                <div class="example-item">
                  <div class="example-catch">
                    <h5>
                      ビジネスプラットフォーム領域
                    </h5>
                    <div class="image">
                      <img src="../../assets/employee_referral_system/ex_img01.png" alt="" />
                    </div>
                  </div>
                  <div class="content-text">
                    <p>
                      ITアーキテクト/技術スペシャリスト、DevOpsコンサルタント、アジャイル開発コンサルタント、テックリードなど
                    </p>
                  </div>
                </div>
                <div class="example-item">
                  <div class="example-catch">
                    <h5>
                      エンベデッド領域
                    </h5>
                    <div class="image">
                      <img src="../../assets/employee_referral_system/ex_img02.png" alt="" />
                    </div>
                  </div>
                  <div class="content-text">
                    <p>
                      アプリケーションエンジニア、プロセス改善コンサルタント、ソフトウェアテストコンサルタント、SysML/UML/Simulinkモデリング技術者、自動車などの組み込み系システムの開発者及びコンサルタントなど
                    </p>
                  </div>
                </div>
                <div class="example-item">
                  <div class="example-catch">
                    <h5>
                      ロボット領域
                    </h5>
                    <div class="image">
                      <img src="../../assets/employee_referral_system/ex_img03.png" alt="" />
                    </div>
                  </div>
                  <div class="content-text">
                    <p>
                      ロボット開発者、要素技術及びロボットソフトウェア開発者、システムインテグレーション技術者、産業用ロボットのメカ技術者、モータ制御技術者など
                    </p>
                  </div>
                </div>
                <div class="example-item">
                  <div class="example-catch">
                    <h5>
                      DX・AIソリューション領域
                    </h5>
                    <div class="image">
                      <img src="../../assets/employee_referral_system/ex_img04.png" alt="" />
                    </div>
                  </div>
                  <div class="content-text">
                    <p>
                      機械学習エンジニア/MLOPSエンジニア、クラウドエンジニア、DXコンサルタント、データサイエンススペシャリスト、データアナリスト、ITコンサルタント、ITアーキテクト/ITエンジニアなど
                    </p>
                  </div>
                </div>
              </div>
              <p class="note">※時期や採用ニーズによって変動します</p>
            </div>
          </div>
          <a href="https://hrmos.co/pages/mamezou-recruit" target="_blank" class="btn btn-02 invert">
            <div class="invert-inner">
              <p>募集職種一覧はこちら</p>
            </div>
          </a>
          <a href="https://hrmos.co/pages/mamezou-recruit/jobs/1750416445459521541" target="_blank" class="btn btn-03">
            <p>社員紹介制度へのエントリーはこちら</p>
          </a>
        </div>
      </div>
    </article>
		<article class="column application-flow full-width">
      <div class="column-inner">
        <div class="title-wrap">
          <h3>
            応募フロー
          </h3>
        </div>
        <div class="content">
          <div class="content-inner">
            <div class="flow-item-wrap">
              <div class="flow-item">
                <div class="icon">
                  <img src="../../assets/employee_referral_system/flow_icon01.png" alt="" />
                </div>
                <div class="flow-text-wrap">
                  <div class="flow-catch">
                    <div class="num">
                      <span>1</span>
                    </div>
                    <h4>
                      社員紹介フォームよりエントリー
                    </h4>
                  </div>
                  <ul class="content-text">
                    <li>・ご興味のあるポジション、弊社の知人技術者の氏名などを記入の上、エントリーください</li>
                    <li>・既に弊社の技術者との接点のある方は、その技術者から人事にご連絡いただくことも可能です</li>
                    <a href="https://hrmos.co/pages/mamezou-recruit/jobs/1750416445459521541" target="_blank" class="underline">社員紹介フォームはこちら</a>
                  </ul>
                </div>
              </div>
              <div class="flow-item">
                <div class="icon">
                  <img src="../../assets/employee_referral_system/flow_icon02.png" alt="" />
                </div>
                <div class="flow-text-wrap">
                  <div class="flow-catch">
                    <div class="num">
                      <span>2</span>
                    </div>
                    <h4>
                      弊社社員からのご連絡
                    </h4>
                  </div>
                  <ul class="content-text">
                    <li>・弊社の技術者もしくは人事より、今後の進め方をご連絡いたします</li>
                  </ul>
                </div>
              </div>
              <div class="flow-item">
                <div class="icon">
                  <img src="../../assets/employee_referral_system/flow_icon03.png" alt="" />
                </div>
                <div class="flow-text-wrap">
                  <div class="flow-catch">
                    <div class="num">
                      <span>3</span>
                    </div>
                    <h4>
                      カジュアル面談
                    </h4>
                  </div>
                  <ul class="content-text">
                    <li>・弊社の技術者もしくは人事とのカジュアル面談を設定いたします</li>
                    <li>・弊社からの情報のご提供、ご質問へのご回答をいたします</li>
                    <li>・カジュアル面談の実施時点で、正式にご応募いただく必要はありません</li>
                  </ul>
                </div>
              </div>
              <div class="flow-item">
                <div class="icon">
                  <img src="../../assets/employee_referral_system/flow_icon04.png" alt="" />
                </div>
                <div class="flow-text-wrap">
                  <div class="flow-catch">
                    <div class="num">
                      <span>4</span>
                    </div>
                    <h4>
                      正式ご応募
                    </h4>
                  </div>
                  <ul class="content-text">
                    <li>・豆蔵への正式な応募意思を、接点のある技術者もしくは人事にお伝えください。正式な応募の流れをご案内いたします</li>
                    <li>・選考に必要な書類をご提出いただきます</li>
                  </ul>
                </div>
              </div>
              <div class="flow-item">
                <div class="icon">
                  <img src="../../assets/employee_referral_system/flow_icon05.png" alt="" />
                </div>
                <div class="flow-text-wrap">
                  <div class="flow-catch">
                    <div class="num">
                      <span>5</span>
                    </div>
                    <h4>
                      選考
                    </h4>
                  </div>
                  <ul class="content-text">
                    <li>・書類選考→面接（複数回）を実施いたします</li>
                    <p> ※応募後の選考プロセスは通常のキャリア採用と同様です</p>
                    <p>※選考内容は募集職種・ポジションによって変動する可能性があります</p>
                    <p>※ご応募いただいたポジション以外での選考をご提案することがあります</p>
                  </ul>
                </div>
              </div>
              <div class="flow-item">
                <div class="icon">
                  <img src="../../assets/employee_referral_system/flow_icon06.png" alt="" />
                </div>
                <div class="flow-text-wrap">
                  <div class="flow-catch">
                    <div class="num">
                      <span>6</span>
                    </div>
                    <h4>
                      内定・ご入社
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
		<article class="column voice">
      <div class="column-inner">
        <div class="title-wrap">
          <h3>
            社員紹介入社者の声
          </h3>
        </div>
        <div class="content">
          <div class="content-inner">
            <div class="voice-item-wrap">
              <div class="voice-item">
                <div class="voice-catch">
                  <h4>
                    Aさん
                  </h4>
                  <span class="icon"></span>
                </div>
                <ul class="voice-text-item-wrap">
                  <li class="content-text voice-text">
                    <div class="qa-box question">
                      <p>豆蔵への入社を決めた理由を教えてください。</p>
                    </div>
                    <div class="qa-box answer">
                      <p>上流から実装まで幅広く携われることや、機械学習プロジェクトにも携われると感じたためです。また、様々なお客様への支援が出来る事も魅力でした。</p>
                    </div>
                  <li class="content-text voice-text">
                    <div class="qa-box question">
                      <p>社員紹介を通じて入社して良かったことを教えてください。</p>
                    </div>
                    <div class="qa-box answer">
                      <p>同じ研究分野の友人が所属しており、キャリアパスを描きやすかったです。会社の雰囲気も事前に聞いていたので安心して入社出来ました。</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="voice-item">
                <div class="voice-catch">
                  <h4>
                    Bさん
                  </h4>
                  <span class="icon"></span>
                </div>
                <ul class="voice-text-item-wrap">
                  <li class="content-text voice-text">
                    <div class="qa-box question">
                      <p>豆蔵への入社を決めた理由を教えてください。</p>
                    </div>
                    <div class="qa-box answer">
                      <p>自身のキャリアパスに悩んでいた時期だったので、自らの裁量で仕事を進めていける点、やりたい業務ができる点が魅力に感じたからです。<br>
                      以前の同僚からの紹介ということもあり、入社後の働き方、仕事のイメージがつきやすかったことも決め手になりました。</p>
                    </div>
                  <li class="content-text voice-text">
                    <div class="qa-box question">
                      <p>社員紹介を通じて入社して良かったことを教えてください。</p>
                    </div>
                    <div class="qa-box answer">
                      <p>以前経験したことのある業務であることや、同僚との仕事の進め方はお互い心得ているので、立ち上がりがスムーズでした。<br>
                      結果的に早い段階から新しい業務にチャレンジできたことは良かった点です。</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="voice-item">
                <div class="voice-catch">
                  <h4>
                    Cさん
                  </h4>
                  <span class="icon"></span>
                </div>
                <ul class="voice-text-item-wrap">
                  <li class="content-text voice-text">
                    <div class="qa-box question">
                      <p>豆蔵への入社を決めた理由を教えてください。</p>
                    </div>
                    <div class="qa-box answer">
                      <p>前職で役職定年となることもあり、最後に自分の好きな技術で活躍できる場を探していました。そんな中で豆蔵社員にお声掛けいただき、自分のやりたい事が出来そうだと思った事が理由です。</p>
                    </div>
                  <li class="content-text voice-text">
                    <div class="qa-box question">
                      <p>社員紹介を通じて入社して良かったことを教えてください。</p>
                    </div>
                    <div class="qa-box answer">
                      <p>周りの皆さんの技術力が高く、日々学びが多いです。この歳になっても学習出来る環境がある事が魅力です。</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
		<article class="column faq">
      <div class="column-inner">
        <div class="title-wrap">
          <h3>
            FAQ
          </h3>
        </div>
        <div class="content">
          <div class="content-inner">
            <div class="faq_list">
              <FaqLine question="社員紹介制度の対象になる職種を教えてください。" answer="<a href='https://hrmos.co/pages/mamezou-recruit' target='_blank' class='underline'>こちら</a>に掲載している全ての職種が対象になります。開発エンジニア、アーキテクト、テックリード、コンサルタント、ロボット系エンジニアなど、幅広いポジションでの募集を行っています。" />
              <FaqLine question="すぐの転職は考えていないのですが、エントリーしてもよろしいですか？" answer="「応募意思不問」での募集になりますので、問題ありません。社員紹介でエントリーいただき弊社からの情報提供を経て、豆蔵への転職に興味を持ったタイミングで、正式にご応募ください。" />
              <FaqLine question="選考プロセスについて教えてください。" answer="履歴書や職務経歴書などのご準備は必要ありません。<a href='https://hrmos.co/pages/mamezou-recruit/jobs/1750416445459521541' target='_blank' class='underline'>こちらのエントリーフォーム</a>に必要事項を記載の上、送信ください。" />
              <FaqLine question="カジュアル面談では、どのような話をしますか？" answer="豆蔵の事業内容や技術領域、社風や働き方についてお話いたします。その後、なお、お互いの相互理解の場ですので、選考ではありません。" />
              <FaqLine question="カジュアル面談後に、正式応募をお断りしてよいでしょうか？" answer="お断りいただいて構いません。後日、豆蔵への転職の関心が高まりましたら、ご応募ください。" />
              <FaqLine question="正式に応募する場合は、どのような手続きを進めればよいでしょうか？" answer="社員紹介経由でご応募いただく場合は、応募意思を接点のある技術者もしくは人事にお伝えください。正式な応募の流れをご案内いたします。" />
              <FaqLine question="カジュアル面談と面接の違いを教えてください。" answer="カジュアル面談は「応募意思不問」でご参加いただき、豆蔵からの情報提供を行いながら疑問を解消いただく、相互理解の場です。一方で、面接は選考の場になります。" />
              <FaqLine question="以前、豆蔵を受験したのですが、社員紹介制度で改めてエントリーしてもよいですか？" answer="再応募は可能です。改めて面談もしくは面接から進めさせていただきます。" />
              <FaqLine question="社員紹介制度の対象外となるケースがあれば教えてください。" answer="以下に該当する場合は対象外とさせていただきます。<br>・すでに選考に進まれている方<br>・新卒採用" />
            </div>
          </div>
        </div>
      </div>
    </article>
    <a href="https://hrmos.co/pages/mamezou-recruit/jobs/1750416445459521541" target="_blank" class="btn btn-04">
      <p>社員紹介制度へのエントリーはこちら</p>
    </a>
  </div>
</template>

<script>
// @ is an alias to /src
import FaqLine from './FaqLine.vue';
export default {
  name: 'referral-article',
  props: {
    isReverse: Boolean,
    text: String,
    image: String,
  },
  components: {
    FaqLine,
  },
}
</script>

<style lang="scss" scoped>
  .referral-article{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    p,a,h3,h4,h5,li{
      margin: 0;
      letter-spacing: 0.1em;
      text-align: justify;
      font-weight: 500;

    }
    h3,h4,h5{
      font-family: 'ots-mincho', serif;
      line-height: 2;
      letter-spacing: 0.03em;
    }
    .num{
      span{
        font-family: 'ots-mincho', serif;
      }
    }
  }
  .column{
    width: 920px;
    background-color: #fff;
    margin:140px auto 0;
    @media print, screen and (max-width: 1160px) {
      width: 91%;
      max-width: 920px;
      margin:80px auto 0;
    }
    &.full-width{
      margin: 140px -200% 0;
      padding:0 200%;
      @media print, screen and (max-width: 1160px) {
        margin:80px -200% 0;
      }
    }
    &-inner{
      width: 100%;
      padding:90px 0 120px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-direction: column;
      bottom: -0.5em;
      @media print, screen and (max-width: 1160px) {
        padding:70px 0;
      }
      .title-wrap{
        margin-bottom: 40px;
        display: inline-block;
        position: relative;
        &::before{
          content:"";
          width:100%;
          height: 1em;
          background-color:#ffc172;
          position:absolute;
          left: 0;
          right: 0;
          bottom: -0.5em;
          @media print, screen and (max-width: 1160px) {
          height: 0.5em;
          bottom: -0.25em;
          }
        }
        h3{
          font-size:30px;
          line-height: 1em;
          position: relative;
          font-weight: 400;
          letter-spacing: 0.05em;
          margin: 0 0.2em;
            @media print, screen and (max-width: 1160px) {
            font-size: 18px;
            }
          }
        }
      .content-catch{
        text-align: center;
        font-family: 'ots-mincho', serif;
        font-size: 22px;
        @media print, screen and (max-width: 1160px) {
          font-size: 13px;
        }
      }
      &:not(.feature){
      .content-text{
        font-size: 14px;
        @media print, screen and (max-width: 1160px) {
          font-size: 12px;
        }
      }
    }
  }
}
a.btn{
  width:468px;
  height:78px;
  background: linear-gradient(to left, rgba(243,192,114,1) -20%, rgba(77,55,139,1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50vh;
  border:3px solid #fff;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  @media print, screen and (max-width: 1160px) {
    width:282px;
    height:57px;
  }
  p{
    color:#fff;
    font-size: 18px;
    margin: 0;
    letter-spacing: 0.03em;
    @media print, screen and (max-width: 1160px) {
    font-size: 12px;
    margin-left: -1em;
    }
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
    right: 2em;
    width: 0.7em;
    border-top: 2px solid #fff;
    transition: right .5s,left .5s;
    z-index: 1;
    @media print, screen and (max-width: 1160px) {
      right: 1.3em;
      width: 0.5em;
    }
  }
  &::before{
    top: calc(50% - 0.249em);
    transform: rotate(37deg);
    @media print, screen and (max-width: 1160px) {
      top: calc(50% - 0.187em);
    }
  }
  &::after {
    bottom: calc(50% - 0.249em);
    transform: rotate(-37deg);
    @media print, screen and (max-width: 1160px) {
      bottom: calc(50% - 0.187em);
    }
  }
  &-01{
    margin-top: -2.5em;
    // position: relative;
    @media print, screen and (max-width: 1160px) {
      margin-top: -2em;
    }
  }
  &-02{
    margin: 60px auto 30px;
    @media print, screen and (max-width: 1160px) {
      margin: 40px auto 20px;
    }
  }
  &-03{
    margin: 0 auto -30px;
    @media print, screen and (max-width: 1160px) {
      margin: 0 auto -20px;
    }
  }
  &-04{
    margin: 60px auto 120px;
    @media print, screen and (max-width: 1160px) {
      margin: 40px auto 80px;
    }
  }
  &.invert{
    border:initial;
    padding: 3px;
    .invert-inner{
      background-color: #fff;
      width: 100%;
      height: 100%;
      border-radius: 50vh;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    p{
      color:#533488;
      margin: 0;
    }
    &::before,
    &::after{
      border-color: #533488;
    }
  }
}
.feature{
  position: relative;
  .content{
    width:800px;
    @media print, screen and (max-width: 1160px) {
      width: 88%;
      max-width: 760px;
    }
    &-inner{
      margin: 2.5em 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media print, screen and (max-width: 1160px) {
        flex-direction: column-reverse;
        margin: 1em 0 0;
      }
    }
    &-text{
      width: 51.25%;
      font-size: 15px;
      @media print, screen and (max-width: 1160px) {
        width: 100%;
        font-size: 12px;
      }
    }
    .image{
      width: 41.25%;
      max-width: 330px;
      @media print, screen and (max-width: 1160px) {
        width: 88.3%;
        margin: 0 0 2em;
      }
    }
  }
}
.merit{
  .content-inner{
    @media print, screen and (max-width: 1160px) {
      width: 100%;
    }
  }
  &-item-wrap{
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    gap: 25px;
    justify-content: center;
  }
  &-item{
    width:380px;
    background: linear-gradient(135deg, rgba(243,192,114,1) 0%, rgba(77,55,139,1) 50%);
    background-size: 300% 300%;
    padding: 3.3em 5.5%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    @media print, screen and (max-width: 1160px) {
      max-width:500px;
      width: 100%;
      padding: 3.3em 3em;
    }
    .merit-catch{
      display: flex;
      align-items: center;
      img{
        width:73px;
        margin-right: 5%;
        @media print, screen and (max-width: 1160px) {
          width: 66px;
          margin-right: 7%;
          margin-left: 2%;
        }
      }
      .num{
        width:73px;
        margin-right: 5%;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        @media print, screen and (max-width: 1160px) {
          width: 66px;
          margin-right: 7%;
          margin-left: 2%;
        }
        p{
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.15em;
          display: inline-block;
          @media print, screen and (max-width: 1160px) {
            font-size: 10px;
          }
        }
        span{
        display: inline-block;
        margin-top: -5px;
        font-size: 117px;
        line-height: 1;
          @media print, screen and (max-width: 1160px) {
            font-size: 97px;
          }
        }
      }
      h4{
        color:#fff;
        font-size: 23px;
        line-height: 1.8;
        margin-bottom: -1em;
        white-space: nowrap;
        letter-spacing: 0;
        @media print, screen and (max-width: 1160px) {
          font-size: 19px;
        }
      }
    }
    .content-text{
      color:#fff;
      text-align: justify;
      margin: 2.5em 0 0;
      flex-grow: 1;
    }
    &:nth-child(1){
      background-position: 15% 15%;
    }
    &:nth-child(2){
      background-position: 40% 40%;
      h4{
        margin-bottom: -0.3em;
      }
    }
    &:nth-child(3){
      background-position: 40% 40%;
    }
    &:nth-child(4){
      background-position: 60% 60%;
    }
  }


}
.position{
  .content{
    width:720px;
    @media print, screen and (max-width: 1160px) {
      width: 89%;
      max-width: 760px;
    }
    .example{
      &-wrap{
        width: 100%;
        margin-top:50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .note{
          font-size: 12px;
          align-self: flex-end;
          @media print, screen and (max-width: 1160px) {
            font-size: 11px;
            margin-top: 20px;
          }
        }
      }
      &-ttl{
        font-size: 23px;
        padding:0.5em 1.5em;
        border-top: 1px solid #533488;
        border-bottom: 1px solid #533488;
        @media print, screen and (max-width: 1160px) {
          font-size: 17px;
        }
      }
      &-item-wrap{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        @media print, screen and (max-width: 1160px) {
          flex-direction: column;
          gap: 50px;
        }
      }
      &-item{
        padding:50px 5%;
        display: flex;
        width: 50%;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        &:nth-child(odd){
          border-right: 1px solid #533488;
        }
        &:nth-child(-n+2){
          border-bottom: 1px solid #533488;
        }
        @media print, screen and (max-width: 1160px) {
          padding: 0;
          border: initial!important;
          width:100% ;
          flex-direction: row;
          flex-wrap: wrap;
        }
        .content-text{
          word-break: break-all;
          margin-top: 10px;
        }
      }
      &-catch{
        display: flex;
        flex-direction: column;
        width: 100%;
        @media print, screen and (max-width: 1160px) {
          flex-direction: row-reverse;
          align-items: center;
          justify-content: flex-end;
        }
        .image{
          width: 90px;
          margin: 1.5em auto;
          @media print, screen and (max-width: 1160px) {
            margin: 0 0.5em 0 0;
            width: 63px;
            }
          }
        h5{
          font-weight: 500;
          letter-spacing: 0.02em;
          font-size: 20px;
          text-align: center;
          @media print, screen and (max-width: 1160px) {
            font-size: 16px;
            text-align: left;
          }
        }
      }
    }
  }
}
.application-flow{
  @media print, screen and (max-width: 1160px) {
    margin:80px auto 0!important;
    padding: 0!important;
  }
  .content{
    width:800px;
    @media print, screen and (max-width: 1160px) {
      width: 89%;
      max-width: 760px;
    }
  }
  .flow{
    &-item-wrap{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin: 20px auto -20px;
      @media print, screen and (max-width: 1160px) {
        gap: 50px;
        margin: 20px auto 0;
      }
    }
    &-item{
      display: flex;
      align-items: center;
      gap: 40px;
      height: 230px;
      overflow: visible;
      @media print, screen and (max-width: 1160px) {
        height: auto;
        align-items:stretch;
        gap: 18px;
      }
      .icon{
        margin-top: 6em;
        width: 138px;
        position: relative;
        @media print, screen and (max-width: 1160px) {
          width: max(60px,9vw);
          margin-top: 0;
        }
        img{
          position: relative;
        }
      }
      &:not(:last-child){
        .icon{
          &::before{
            content:"";
            width: 300px;
            height: 10px;
            background-color: #e8e8e8;
            position: absolute;
            left: 50%;
            top: 50%;
            @media print, screen and (max-width: 1160px) {
              width: 7px;
              height: 100%;
              top: 60px;
            }
          }
        }
      }
      &:nth-child(odd){
        width:100%;
        .icon{
          &::before{
            transform: rotate(43deg);
            transform-origin: top left;
            @media print, screen and (max-width: 1160px) {
              transform: rotate(0deg) translateX(-50%);
            }
          }
        }
      }
      &:nth-child(even){
        width:555px;
        @media print, screen and (max-width: 1160px) {
          width:100%;
        }
        .icon{
          &::before{
            transform: rotate(137deg);
            transform-origin: top left;
            @media print, screen and (max-width: 1160px) {
              transform: rotate(0deg) translateX(-50%);
            }
          }
        }
      .flow-text-wrap{
          margin-top: 3.5em;
          @media print, screen and (max-width: 1160px) {
            margin-top: 0;
          }
        }
      }
      &:last-child{
        h4{
          margin: 0!important;
        }
      }
    }
    &-text-wrap{
      position: relative;
      flex: 1;
      .num{
        span{
          line-height: 1;
          font-size:74px;
          @media print, screen and (max-width: 1160px) {
            font-size:38px;
          }
        }
      }
      h4{
        font-size: 26px;
        margin: -0.2em 0 0.2em;
        @media print, screen and (max-width: 1160px) {
          font-size: 16px;
          margin: 0 0 1.2em;
          letter-spacing:0.02em;
        }
      }
      a{
        margin-top: 10px;
        display: inline-block;
      }
      p,li{
        letter-spacing: 0.03em;
        line-height: 1.8;
        text-indent: -1em;
        margin-left: 1em;
      }
    }
  }
}
.voice{
  .content{
    width:720px;
    @media print, screen and (max-width: 1160px) {
      width: 95%;
      max-width: 720px;
    }
  }
  &-item-wrap{
    margin-top: 4em;
    display: flex;
    flex-direction: column;
    gap: 5em;
    @media print, screen and (max-width: 1160px) {
      margin-top: 2em;
    }
  }
  &-item{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &-catch{
    display:inline-block;
    font-size: 23px;
    padding: 0.2em 2.7em;
    margin: 0 auto 30px;
    border-top: 1px solid #533488;
    border-bottom: 1px solid #533488;
    position: relative;
    @media print, screen and (max-width: 1160px) {
      font-size: 17px;
      margin: 0 auto 40px;
      padding: 0.4em 2.7em;
    }
    &::before {
      content:"";
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0.5em 0.5em 0;
      border-color: transparent #533488 transparent transparent;
      right: 26%;
      bottom: -0.5em;
    }
    &::after {
      content:"";
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 calc(0.5em - 1px) calc(0.5em - 1px) 0;
      border-color: transparent #fff transparent transparent;
      right: calc(26% + 1px);
      bottom: calc(-0.5em + 2px);
    }
    .icon{
      position: absolute;
      right: -15%;
      bottom: -27%;
      background-image:url(../../assets/employee_referral_system/voice_icon.png);
      width:50px;
      height: 50px;
      background-repeat: no-repeat;
      background-size: contain;
      @media print, screen and (max-width: 1160px) {
        width:37px;
        height: 37px;
        bottom: -35%;
      }
    }
  }
  &-text{
    .qa-box{
      display: flex;
      justify-content: space-between;
      @media print, screen and (max-width: 1160px) {
        align-items: center;
      }
      &::before{
        margin-right: 50px;
        font-family: 'ots-mincho', serif;
        font-size: 30px;
        @media print, screen and (max-width: 1160px) {
          font-size: 23px;
          margin-right: min(20px, 6%);
        }
      }
      &.question{
        padding: 2em 5.8%;
        @media print, screen and (max-width: 1160px) {
          background-color: #fafafa;
          padding: 1.8em 6%;
        }
        &::before{
          content:"Q";
        }
      }
      &.answer{
        padding: 1em 5.8%;
        background-color: #ffc172;
        @media print, screen and (max-width: 1160px) {
          padding: 1.8em 6%;
        }
        &::before{
          content:"A";
          margin-top: 0.25em;
          @media print, screen and (max-width: 1160px) {
            margin-top: 0;
          }
        }
      }
      p{
        flex: 1;
        align-self: center;
        line-height: 1.8;
      }
    }
  }
}
.faq{
  .content{
    width:720px;
    @media print, screen and (max-width: 1160px) {
      width: 95%;
      max-width: 720px;
    }
  }
}
  </style>
